<template>
  <div>

    <BackButton v-if="$route.name !== 'products'" :namedRoutes="{ products: $t('common.products'), product: $t('common.product')}"></BackButton>

    <add-edit-product-view v-if="$route.name !== 'product' && isLandlord()"></add-edit-product-view>
    <product-details @isDeleted="(boolean) => {isDetailDeleted = boolean}" :product="product" :time_limit="product.time_limit" v-if="$route.name === 'product'"></product-details>
    <LandlordsTable v-if="isSuperAdmin() && !isDetailDeleted && product.type !== 'easyParking' && $route.name === 'product'" :product="product"></LandlordsTable>
    <TenantsTable v-if="!isDetailDeleted && isLandlord() && $route.name === 'product'"  :product="product"></TenantsTable>
    <products-delayed-table :partner="product" :tenant="tenant" :products="product.defferedProducts" v-if="!isDetailDeleted && $route.name !== 'add-product' && $route.name !== 'edit-product' && product.type === 'guestParking' && product.type !== 'conferenceParking'"></products-delayed-table>
    <Permits v-if="!isDetailDeleted && isTenant() && product.type === 'permitPack' && $route.name === 'product'"></Permits>
    <KiosksTable v-if="!isDetailDeleted && isTenant() && product.type === 'guestParking' && $route.name === 'product'" :kiosks="product.kiosks"></KiosksTable>
    <PricingRules v-if="!isDetailDeleted && product.type === 'guestParking' || product.type === 'easyParking' && $route.name === 'product'"></PricingRules>
    <ConferenceRules v-if="!isDetailDeleted && product.type === 'conferenceParking' && $route.name === 'product'"></ConferenceRules>
    <ConferenceParkings v-if="!isDetailDeleted && product.type === 'conferenceParking' && $route.name === 'product'"></ConferenceParkings>

    <BackButton v-if="$route.name !== 'products'" :namedRoutes="{ products: $t('common.products'), product: $t('common.product')}"></BackButton>

  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import BackButton from 'common/BackButton';
import PricingRules from 'pricingrules/PricingRules';
import ConferenceRules from 'conferencerules/ConferenceRules';
import ConferenceParkings from 'parkings/ConferenceParkings';
import AddEditProductView from './AddEditProductView';
import ProductsDelayedTable from './ProductsDelayedTable';
import ProductDetails from './ProductDetails';
import Permits from './Permits';
import TenantsTable from './TenantsTable';
import LandlordsTable from './LandlordsTable';
import KiosksTable from './KiosksTable';

export default {
  components: {
    BackButton,
    AddEditProductView,
    ProductDetails,
    Permits,
    TenantsTable,
    LandlordsTable,
    PricingRules,
    KiosksTable,
    ConferenceRules,
    ConferenceParkings,
    ProductsDelayedTable,
  },
  computed: {
    product() {
      return this.$store.getters[`${this.role()}/product/product`];
    },
    routeAcceptsMobileScreen() {
      return typeof this.$route.meta.onMobileScreen === 'object';
    },
    ...mapGetters({
      tenant: 'tenants/tenant/tenant',
      isMobileScreen: 'screen/isMobileScreen',
    }),
  },
  methods: {
    role() {
      return this.isLandlord() ? 'products' : 'tenants';
    },
  },
  data() {
    return {
      isDetailDeleted: false,
    };
  },
};
</script>
<style lang="scss" scoped>
  @import '~styles/variables.scss';
  @import '~styles/blocks/details.scss';
  @import '~node_modules/leaflet/dist/leaflet.css';
</style>



// WEBPACK FOOTER //
// src/components/products/MainView.vue